import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import utils from "src/components/utils";
import FaqArea from "src/components/FaqArea";
import { useParams } from "react-router-dom";

export default function Faq() {
  const { faq_id } = useParams();
  const [faqs, setFaqs] = useState(null);
  const [faq, setFaq] = useState(null);

  const completeFind = (res) => {
    setFaq(res.data);
  }

  const completeList = (res) => {
    setFaqs(res.data);
  }

  const find = { crud: { data: {}, changed: {} }, cfg: { url: `Faq/${faq_id}` }, complete: completeFind };
  const list = { crud: { data: {}, changed: {} }, cfg: { url: 'Faq' }, complete: completeList };

  useEffect(() => {
    if (utils.isEmpty(faq_id)) {
      utils.call(list);
    } else {
      utils.call(find);
    }
  }, []);


  const onClickFaq = (f) => {
    window.location.href = '/faq' + (f ? '/' + f.id : '');
  }


  if (!utils.isEmpty(faqs)) {
    return <View name="faqs">
      <div style={{ maxWidth: 1200, margin: '2rem auto', fontFamily: 'Arial', textAlign: 'center' }}>
        <h1>{utils.lng('selecione_faq', 'Selecione um FAQ')}</h1>
        {faqs.map((f, index) => (
          <div
            key={index}
            onClick={() => {
              onClickFaq(f);
            }}
            style={{
              background: '#fff',
              borderRadius: 8,
              cursor: 'pointer',
              marginBottom: 10,
              padding: 20,
              textAlign: 'center',
              fontSize: 20,
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              border: '1px solid #dce6f2',
            }}
          >
            {utils.nvl(f.pais?.descricaoInternacional, f.pais?.descricao)}
          </div>
        ))}
      </div>
    </View>
  }

  return (
    <View name="faq">
      <div style={{ maxWidth: 1200, margin: '2rem auto', fontFamily: 'Arial' }}>
        <h1 style={{ textAlign: 'center', color: '#387dcb', padding: 20 }}>
          <i className="fa fa-arrow-left" style={{ paddingRight: 10, cursor: 'pointer' }} onClick={() => {
            onClickFaq();
          }} />
          {utils.lng('titulo_faq', utils.nvl(faq?.title, 'Perguntas Frequentes (FAQ)'))}</h1>

        {faq?.id &&
          <FaqArea id_faq={faq?.id} />
        }
      </div>
    </View>
  );
}